import { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import CONFIG from '../../config/apiConfig';

export const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const token = Cookies.get('auth_token');
    if (token) {
      fetchProfileData(token);
    }
  }, []);

  const fetchProfileData = async (token) => {
    try {
      const response = await axios.get(CONFIG.API_URL + '/profile', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProfile(response?.data?.data);
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  return (
    <ProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
